var _path, _ellipse, _ellipse2, _line, _line2, _line3, _line4, _ellipse3, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _g, _g2, _g3, _path19, _ellipse4, _ellipse5, _g4, _path20, _line16, _line17, _line18, _line19, _line20, _rect, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdNowStepTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 117,
    viewBox: "0 0 174 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64.909C-2.31566e-05 75.3663 8.7374 100.34 27.6375 111.324C46.9358 122.54 63.1158 113.156 85.8738 113.526C103.063 113.805 113.656 118.766 129.896 113.526C152.876 106.111 177.808 93.3989 172.537 71.3301C168.872 55.9827 151.416 56.2319 140.557 44.1782C129.723 32.1539 130.885 19.7399 117.46 10.2384C88.3981 -10.329 52.9552 5.08162 25.8608 27.8504C12.0937 39.4196 2.31567e-05 54.4518 0 64.909Z",
    fill: "#031A6B",
    fillOpacity: 0.02
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.0754,
    cy: 34.9162,
    rx: 19.1007,
    ry: 19.1008,
    stroke: "#CAD0E1",
    strokeWidth: 0.489763,
    strokeLinecap: "round",
    strokeDasharray: "1.96 2.94"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.8346,
    cy: 30.8551,
    rx: 31.8346,
    ry: 30.8551,
    transform: "matrix(-1 0 0 1 76.7904 45.6909)",
    stroke: "#CAD0E1",
    strokeWidth: 0.489763,
    strokeLinecap: "round",
    strokeDasharray: "1.96 2.94"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 53.9115,
    y1: 21.2028,
    x2: 53.9115,
    y2: 22.3222,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 53.9115,
    y1: 24.4912,
    x2: 53.9115,
    y2: 25.6107,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 51.8125,
    y1: 23.5117,
    x2: 52.9319,
    y2: 23.5117,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 54.7511,
    y1: 23.5117,
    x2: 55.8706,
    y2: 23.5117,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.419,
    cy: 81.1988,
    rx: 12.9787,
    ry: 12.9787,
    stroke: "#CAD0E1",
    strokeWidth: 0.489763,
    strokeLinecap: "round",
    strokeDasharray: "1.96 2.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7551 29.1021C36.7551 30.2094 35.8574 31.1072 34.75 31.1072C33.6426 31.1072 32.7449 30.2094 32.7449 29.1021C32.7449 27.9947 33.6426 27.0969 34.75 27.0969C35.8574 27.0969 36.7551 27.9947 36.7551 29.1021Z",
    stroke: "#CAD0E1",
    strokeWidth: 0.489763
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.833 16.0161C105.833 16.7309 105.254 17.3103 104.539 17.3103C103.824 17.3103 103.245 16.7309 103.245 16.0161C103.245 15.3014 103.824 14.7219 104.539 14.7219C105.254 14.7219 105.833 15.3014 105.833 16.0161Z",
    stroke: "#CAD0E1",
    strokeWidth: 0.489763
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.083 71.1411C153.083 71.8559 152.504 72.4353 151.789 72.4353C151.074 72.4353 150.495 71.8559 150.495 71.1411C150.495 70.4264 151.074 69.8469 151.789 69.8469C152.504 69.8469 153.083 70.4264 153.083 71.1411Z",
    stroke: "#CAD0E1",
    strokeWidth: 0.489763
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.625,
    cy: 99.4771,
    r: 2.25512,
    stroke: "#CAD0E1",
    strokeWidth: 0.489763
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.813 40.0671C119.008 59.6126 106.032 74.876 97.8956 80.0644L97.8956 81.4437C120.063 65.6812 112.41 47.2916 105.813 40.0671Z",
    fill: "#CAD0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.988 38.885C102.019 37.046 95.5535 32.6982 93.4423 30.0186C96.6861 30.1499 103.536 32.1071 104.988 38.885Z",
    fill: "#CAD0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.792 45.9781C106.032 46.3721 101.59 46.0175 97.8956 41.4464C100.064 40.5926 105.079 40.3036 107.792 45.9781Z",
    fill: "#CAD0E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.101 57.4059C108.342 56.6834 104.658 53.9381 103.998 48.7365C106.472 48.8022 111.157 50.628 110.101 57.4059Z",
    fill: "#CAD0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.792 67.6515C106.417 66.7977 103.833 63.5532 104.493 57.4059C106.857 58.1283 110.827 61.1889 107.792 67.6515Z",
    fill: "#CAD0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.535 76.9119C99.9298 74.876 99.2481 69.937 101.359 66.4693C103.394 67.7172 106.076 71.5527 100.535 76.9119Z",
    fill: "#CAD0E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.998 78.0941C105.263 76.1238 109.243 71.8679 115.049 70.6069C113.785 73.9565 109.804 80.1433 103.998 78.0941Z",
    fill: "#CAD0E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.091 67.6515C112.025 64.8931 114.785 59.1003 118.348 57.997C118.727 61.2151 117.805 67.6515 111.091 67.6515Z",
    fill: "#CAD0E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.4 56.8148C113.235 53.3996 113.598 46.2539 116.369 44.9929C117.908 47.8827 119.469 54.2928 113.4 56.8148Z",
    fill: "#CAD0E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.091 44.9929C111.091 44.9929 107.297 40.4612 109.441 33.1711C111.75 35.7587 115.313 41.7458 111.091 44.9929Z",
    fill: "#CAD0E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8815 62.9021C92.8815 62.9021 94.6116 62.623 95.3482 61.8864C96.0849 61.1498 96.3639 59.4197 96.3639 59.4197C96.3639 59.4197 96.643 61.1498 97.3796 61.8864C98.1162 62.623 99.8463 62.9021 99.8463 62.9021C99.8463 62.9021 98.1162 63.1812 97.3796 63.9178C96.643 64.6544 96.3639 66.3845 96.3639 66.3845C96.3639 66.3845 96.0849 64.6544 95.3482 63.9178C94.6116 63.1812 92.8815 62.9021 92.8815 62.9021Z",
    fill: "#CAD0E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M125.277 49.6631C125.277 49.6631 127.007 49.384 127.744 48.6474C128.48 47.9108 128.759 46.1807 128.759 46.1807C128.759 46.1807 129.038 47.9108 129.775 48.6474C130.512 49.384 132.242 49.6631 132.242 49.6631C132.242 49.6631 130.512 49.9421 129.775 50.6788C129.038 51.4154 128.759 53.1455 128.759 53.1455C128.759 53.1455 128.48 51.4154 127.744 50.6788C127.007 49.9421 125.277 49.6631 125.277 49.6631Z",
    fill: "#CAD0E1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.625 59.2646C129.625 59.2646 131.755 58.9211 132.662 58.0141C133.569 57.1071 133.913 54.977 133.913 54.977C133.913 54.977 134.256 57.1071 135.163 58.0141C136.07 58.9211 138.2 59.2646 138.2 59.2646C138.2 59.2646 136.07 59.6082 135.163 60.5152C134.256 61.4222 133.913 63.5523 133.913 63.5523C133.913 63.5523 133.569 61.4222 132.662 60.5152C131.755 59.6082 129.625 59.2646 129.625 59.2646Z",
    fill: "#CAD0E1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.125 103.89C71.125 103.89 73.2551 103.546 74.1621 102.639C75.069 101.732 75.4126 99.602 75.4126 99.602C75.4126 99.602 75.7562 101.732 76.6632 102.639C77.5701 103.546 79.7002 103.89 79.7002 103.89C79.7002 103.89 77.5701 104.233 76.6632 105.14C75.7562 106.047 75.4126 108.177 75.4126 108.177C75.4126 108.177 75.069 106.047 74.1621 105.14C73.2551 104.233 71.125 103.89 71.125 103.89Z",
    fill: "#CAD0E1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2276,
    y1: 41.9668,
    x2: 18.2276,
    y2: 43.781,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2276,
    y1: 45.6918,
    x2: 18.2276,
    y2: 47.506,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 15.4339,
    y1: 44.7123,
    x2: 17.2481,
    y2: 44.7123,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 19.1587,
    y1: 44.7123,
    x2: 20.9729,
    y2: 44.7123,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 14.7712,
    y1: 47.6444,
    x2: 8.42802,
    y2: 54.0591,
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0.489763,
    y1: -0.489763,
    x2: 2.30393,
    y2: -0.489763,
    transform: "matrix(2.7095e-08 1 1 -3.13413e-08 126.291 77.5255)",
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 0.489763,
    y1: -0.489763,
    x2: 2.30393,
    y2: -0.489763,
    transform: "matrix(2.7095e-08 1 1 -3.13413e-08 126.291 81.2505)",
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 0.489763,
    y1: -0.489763,
    x2: 2.1078,
    y2: -0.489763,
    transform: "matrix(-1 -1.45705e-08 -1.45705e-08 1 128.889 81.2505)",
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 0.489763,
    y1: -0.489763,
    x2: 2.1078,
    y2: -0.489763,
    transform: "matrix(-1 -1.56706e-08 -1.35475e-08 1 125.426 81.2505)",
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 0.489763,
    y1: -0.489763,
    x2: 9.17037,
    y2: -0.489763,
    transform: "matrix(0.676828 0.736141 0.685017 -0.728527 128.779 83.5729)",
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 0.489763,
    y1: -0.489763,
    x2: 15.6438,
    y2: -0.489763,
    transform: "matrix(0.678477 0.734622 0.683379 -0.730063 129.513 86.7333)",
    stroke: "#CAD0E1",
    strokeWidth: 0.979526,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2044_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1486 61.6016C35.1486 61.6016 38.4508 66.4016 43.5486 66.4016C48.6465 66.4016 51.9486 61.6016 51.9486 61.6016C51.9486 61.6016 66.3485 77.2015 67.5486 79.0015C68.7487 80.8015 57.7661 78.4015 46.5485 78.4015C35.3308 78.4015 24.9486 81.4015 27.3486 76.6015C29.7486 71.8016 35.1486 61.6016 35.1486 61.6016Z",
    fill: "#D9DDE9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2044_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2 69.4015C31.2 69.4015 25.4515 77.2015 36 75.4015C46.5485 73.6015 65.4 75.4015 65.4 75.4015C65.4 75.4015 66.3485 77.2015 67.5486 79.0015C68.7487 80.8015 57.7661 78.4015 46.5485 78.4015C35.3308 78.4015 24.9486 81.4015 27.3486 76.6015C29.7486 71.8015 31.2 69.4015 31.2 69.4015Z",
    fill: "#B3BAD3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2044_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.226 54.2158C54.226 60.0771 49.4745 64.8285 43.6133 64.8285C37.7521 64.8285 33.0006 60.0771 33.0006 54.2158C33.0006 48.3546 37.7521 43.6031 43.6133 43.6031C49.4745 43.6031 54.226 48.3546 54.226 54.2158Z",
    fill: "#D9DDE9",
    fillOpacity: 0.75,
    stroke: "#818CB5",
    strokeWidth: 4.8
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6006 48.4035C48.5688 48.9625 49.3756 49.7664 49.9496 50.7441C50.5236 51.7218 50.8471 52.843 50.8913 54.0085C50.9356 55.174 50.6994 56.3478 50.2035 57.4259C49.7076 58.5039 48.9673 59.453 48.0484 60.1891C47.1294 60.9252 46.0601 61.4255 44.935 61.6457C43.81 61.8659 42.6641 61.7992 41.5987 61.4516C40.5333 61.1039 39.5814 60.4861 38.8272 59.6527C38.0731 58.8193 37.54 57.7961 37.2752 56.6738C37.4848 57.5624 38.5761 58.3937 39.1732 59.0535C39.9091 59.4784 40.7614 59.8349 41.6049 60.1101C42.4484 60.3854 43.8477 60.3643 44.7384 60.19C45.6291 60.0156 46.4757 59.6195 47.2033 59.0368C47.9309 58.454 48.6226 57.6666 49.0152 56.8131C49.4078 55.9595 49.7015 54.3613 49.6664 53.4386C49.6314 52.5158 49.6295 51.3603 49.175 50.5862C48.7206 49.8121 48.3671 48.8461 47.6006 48.4035Z",
    fill: "white",
    fillOpacity: 0.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.6175,
    cy: 49.338,
    rx: 2.73811,
    ry: 1.88835,
    transform: "rotate(-2.6891 43.6175 49.338)",
    fill: "white",
    fillOpacity: 0.7
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4754,
    cy: 50.5369,
    rx: 0.725579,
    ry: 0.725579,
    transform: "rotate(-2.6891 39.4754 50.5369)",
    fill: "white",
    fillOpacity: 0.7
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2044_1280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.6084,
    y: 40,
    width: 75.2276,
    height: 47.5121,
    rx: 4.8,
    transform: "rotate(4.35584 60.6084 40)",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3703 43.1254C60.5018 41.3993 62.0077 40.1066 63.7338 40.2381L132.493 45.4755C134.219 45.607 135.512 47.1129 135.381 48.839L134.792 56.5703L59.7814 50.8567L60.3703 43.1254Z",
    fill: "#D9DDE9"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 97.7807,
    y1: 75.7352,
    x2: 125.046,
    y2: 77.812,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 2.35086,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 98.3571,
    y1: 68.1686,
    x2: 125.622,
    y2: 70.2454,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 2.35086,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 98.9334,
    y1: 60.6017,
    x2: 126.199,
    y2: 62.6785,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 2.35086,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 97.2043,
    y1: 83.3021,
    x2: 119.535,
    y2: 85.003,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 2.35086,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 65.2913,
    y1: 46.1267,
    x2: 84.6608,
    y2: 47.6021,
    stroke: "white",
    strokeWidth: 2.35086,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.9185,
    y: 56.4243,
    width: 26.7256,
    height: 26.7255,
    rx: 1.8,
    transform: "rotate(4.35584 63.9185 56.4243)",
    fill: "#D9DDE9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5489 78.3529C78.9103 77.1088 78.1082 76.1671 78.251 74.2926C78.3367 73.1676 79.2827 72.5064 79.6596 71.5654C80.0366 70.6244 80.2991 69.4963 80.5083 68.6771C80.7176 67.8578 80.8 67.5411 80.9468 66.6624C81.1279 65.5657 80.6395 62.6615 76.8668 62.3741C73.0953 62.0868 72.1703 64.8834 72.1854 65.9951C72.1974 66.8858 72.2313 67.2115 72.3137 68.0529C72.3961 68.8943 72.483 70.049 72.7129 71.0363C72.9428 72.0236 73.779 72.8205 73.6933 73.9454C73.5505 75.8199 72.6151 76.6292 69.8185 77.4594C67.0119 78.2911 65.1632 79.1813 65.108 79.9055L64.8496 83.2982L85.5761 84.8769L85.8346 81.4842C85.8896 80.7612 84.196 79.6012 81.5489 78.3529Z",
    fill: "#818CB5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2044_1280",
    x: 21,
    y: 61.6016,
    width: 52.6387,
    height: 36.0694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.615686 0 0 0 0 0.733333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_1280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_1280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2044_1280",
    x: 21,
    y: 69.4015,
    width: 52.6387,
    height: 28.2694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.615686 0 0 0 0 0.733333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_1280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_1280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2044_1280",
    x: 29.4006,
    y: 41.2031,
    width: 28.4254,
    height: 28.4254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.599999
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.668689 0 0 0 0 0.690539 0 0 0 0 0.756087 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_1280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_1280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2044_1280",
    x: 51.3503,
    y: 40.3505,
    width: 89.9179,
    height: 70.3874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.615686 0 0 0 0 0.733333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_1280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_1280",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdNowStepTwo);
export default __webpack_public_path__ + "static/media/id-now-step-two.b332ff1db3301898348c5e9dfa4da743.svg";
export { ForwardRef as ReactComponent };